import './patterns.css';

const Patterns = () => {

    return (
        <>
            {/* This div provides a starting point for Kendo Pdf print */}
            <div style={{ height: "1px" }} />
            <img className='pattern-1' src='../images/report/pattern.svg' alt='pattern' />
            <img className='pattern-2' src='../images/report/pattern.svg' alt='pattern' />
        </>
    )
};

export default Patterns;